import { render, staticRenderFns } from "./SeedingOther.vue?vue&type=template&id=15c233a0&scoped=true&"
import script from "./SeedingOther.vue?vue&type=script&lang=js&"
export * from "./SeedingOther.vue?vue&type=script&lang=js&"
import style0 from "./SeedingOther.vue?vue&type=style&index=0&id=15c233a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c233a0",
  null
  
)

export default component.exports